var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45518 10.524L4.45508 3.77407L5.95508 3.77405L5.95516 9.02397L13.584 9.02405L10.6217 6.06175L11.6824 5.00109L16.4554 9.77405L11.6824 14.547L10.6217 13.4864L13.5841 10.524L4.45518 10.524Z",
    fill: "#010103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInArrow);
export default __webpack_public_path__ + "static/media/sign-in-arrow.a09f750a095916bfd486173810bfd5ea.svg";
export { ForwardRef as ReactComponent };